import { combineReducers } from '@ngrx/store';
import { FilterInstanceHelper, SearchHelper } from '../../utils';
import * as filter from './filter/filter.reducer';
import * as search from './search/search.reducer';
import * as sort from './sort/sort.reducer';

export function dataFilterInstanceReducerFactory(filterInstanceHelper: FilterInstanceHelper, searchHelper: SearchHelper): any {
  const filterReducer = filter.filterReducerFactory(filterInstanceHelper);
  const searchReducer = search.searchReducerFactory(searchHelper);
  const sortReducer = sort.sortReducer;
  
  return combineReducers({
    filterState: filterReducer,
    searchState: searchReducer,
    sortState: sortReducer
  });
}
